import Navigation from './partials/navigation';
import Search from './partials/search';

import Home from './pages/home';
import Property from './property';
import Global from './global';
import Shape from "./partials/shape";
import Usps from "./partials/usps";

new Home();
new Property();
new Navigation();
new Global();
new Shape();
// new Search();
new Usps();

